import { useState } from "react";
import { XLg } from "react-bootstrap-icons";
import { Button } from "@components";
import WorkingSetBuilderModal from "../../tasks/components/WorkingSetBuilderModal";

// Shown while building a working set with the full filter bar (from the builder's "build it on
// Trade accounts"): saving opens the builder seeded with these filters to name it.
const WorkingSetBar = ({ filters, onCreated, onExit }) => {
  const [saving, setSaving] = useState(false);

  return (
    <>
      <div className="flex items-center gap-2">
        <div className="flex h-8 items-center gap-x-1.5 whitespace-nowrap rounded-md bg-primary-50 px-2.5 text-sm shadow-sm ring-1 ring-inset ring-primary-300">
          <span className="font-medium text-primary-700">New working set</span>
          <button
            type="button"
            aria-label="Stop building a working set"
            onClick={onExit}
            className="ml-0.5 shrink-0 rounded p-1 hover:bg-primary-100"
          >
            <XLg />
          </button>
        </div>
        <Button
          color="primary"
          className="h-8"
          disabled={filters.length === 0}
          title={filters.length === 0 ? "Add a filter first" : undefined}
          onClick={() => setSaving(true)}
        >
          Save as working set
        </Button>
      </div>
      <WorkingSetBuilderModal
        isOpen={saving}
        initialFilters={filters}
        onClose={() => setSaving(false)}
        onCreated={onCreated}
      />
    </>
  );
};

export default WorkingSetBar;
